import { Action, Reducer } from 'redux';

/**
 * Higher order reducer that resets the state of the input reducer
 * if the output of `predicate(action)` is truthy.
 * @param reducer A redux reducer.
 * @param predicate Recieves an action and returns a boolean value.
 */
export default function withResetReducerOn<S, A extends Action<any>>(
  reducer: Reducer<S, A>,
  predicate: (action: A) => boolean,
) {
  return function resetOnActionReducer(state: S | undefined, action: A) {
    if (predicate(action)) {
      return reducer(undefined, action);
    }

    return reducer(state, action);
  };
}
